export default "__VITE_ASSET__6636973b__"